/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CustomField } from '../../model/customfieldsresponse';

@Component({
  selector: 'zsd-customfields',
  templateUrl: '../../view/customfields/customfields.component.html',
  styleUrls: ['../../view/customfields/customfields.component.scss']
})
export class CustomfieldsComponent implements OnInit {

  @Input('parentForm') public parentForm: FormGroup;
  @Input('customFields') public customFields: CustomField[];
  @Input('fromQuickCall') public fromQuickCall: boolean;
  @Input('id') public id: number;

  readonly DATATYPE_STRING = 0;
  readonly DATATYPE_NUMBER = 1;
  readonly DATATYPE_BOOLEAN = 2;
  readonly DATATYPE_DATE = 3;
  readonly DATATYPE_CURRENCY = 4;
  readonly DATATYPE_HYPERLINK = 5;

  constructor() { }

  ngOnInit() {
  }

}

